/**
 * What a chat attachment is, for drawing it. Photos and videos render inline; a PDF renders as
 * a file card, because an <img> pointed at a PDF is a broken-image icon with the agent's
 * document behind it.
 *
 * Mirrors api.vesr's SupportAttachmentPolicy: a PDF is up to 20 MB, and some Android pickers
 * hand one over as `application/octet-stream`, so the name is a fallback signal.
 */
export const PDF_CONTENT_TYPE = 'application/pdf';

/** Same cap as the server, so an oversize file is refused before it spends the agent's data. */
export const MAX_DOCUMENT_BYTES = 20 * 1024 * 1024;

export const isDocumentAttachment = (attachment?: { contentType?: string | null; fileName?: string | null } | null): boolean => {
	if (!attachment) return false;
	const type = (attachment.contentType ?? '').trim().toLowerCase();
	if (type === PDF_CONTENT_TYPE) return true;
	if (type && type !== 'application/octet-stream') return false;
	return (attachment.fileName ?? '').toLowerCase().endsWith('.pdf');
};

/** "1.4 MB", "820 KB". For the file card and the size refusal. */
export const formatFileSize = (bytes: number): string => {
	if (!Number.isFinite(bytes) || bytes <= 0) return '';
	if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
	return `${Math.max(1, Math.round(bytes / 1024))} KB`;
};
